//import Libraries
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

//import Components
import Layout from '../../hoc/Layout/Layout';
import Fullpage from '../../hoc/Fullpage/Fullpage';
import Greeting from './Greeting/Greeting';
import History from './History/History';
import Locations from './Locations/Locations';
import TitleSection from '../../components/TitleSection/TitleSection';
import Button from '../../components/Button/Button';
import Language from '../../language/language.json';


//import Style classes
import './About.css';


class About extends Component{
    componentDidUpdate() {
        console.log(this.props.location.hash);
        let hash = this.props.location.hash.replace('#', '');
        if (hash) {
            let node = ReactDOM.findDOMNode(this.refs[hash]);
            console.log(ReactDOM, this.refs);
            if (node) {
                node.scrollIntoView();
            }
        }
    }
    render(){
        let lang = this.props.universal.language;
        return (
            <Layout isStore={false} relative={true}> 
                <div className="VideoWrapper">
                    {/* <div className="VideoOverride">
                        <div className="FloatingBoxWrapper">
                            <h3>{Language.aboutVideo.title[lang]}</h3>
                            <p>{Language.aboutVideo.content[lang]}</p>
                        </div>
                    </div> */}
                    <video id="myVideo"
                    muted="true" autoPlay="true" loop="true" preload="auto" playsInline="true">
                        <source src={require('../../assets/video/15sec.mp4')} type="video/mp4"></source>
                        <source src={require('../../assets/video/15sec.webm')} type="video/webm"></source>
                    </video>
                    <div className="Preload">
                        <div>
                            <img className="Logo" src={require('../../assets/logo/logo-main-ko-red.svg')} alt=""/>
                            <img className="Loading" src={require("../../assets/video/loading.gif")} alt=""></img>
                            <p>{"영상을 로딩 중입니다\n잠시만 기다려 주세요"}</p>
                        </div>    
                    </div>
                    {/* <iframe id="myVideo" src="https://www.youtube.com/embed/8HkXJASjJMM?autoplay=1"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen="allowfullscreen"
                    mozallowfullscreen="mozallowfullscreen" 
                    msallowfullscreen="msallowfullscreen" 
                    oallowfullscreen="oallowfullscreen" 
                    webkitallowfullscreen="webkitallowfullscreen"></iframe> */}
                </div>
                <TitleSection 
                    id="History"
                    data={Language.titles.History} 
                    lang={lang}/>
                <History lang={lang}/>
                <TitleSection 
                    id="Locations"
                    data={Language.titles.Location} 
                    lang={lang}/>
                <Locations lang={lang}/>
            </Layout>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        universal: state.universal,
    };
}



export default connect(mapStateToProps, null)(About);


// WEBPACK FOOTER //
// ./src/pages/About/About.js